<div [ngClass]="{'active-alert': showAlert}"
    class="{{ cssClass() }} alert-dismissable alert-wrapper alertCenter">
    <div><span class="alertCloseBtn" (click)="closeDiv()"><i class="fa fa-times" aria-hidden="true"></i></span></div>
    <div class="icon-area">
        <p class="title title-1" *ngIf="alert.type==3">Warning</p>
        <p class="title title-2">Info</p>
        <p class="title title-3">Error</p>
        <p class="title title-4">Success</p>
        <p class="title title-5">Warning! Relationship(s) Not Saved</p>
    </div>
    <div class="msg-area">
        <p class="text" id="printSection">{{alert.message}}<p>
    </div>
</div>
